export default function SnappedEndMill({ size = 180 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-label="Snapped end mill">
      {/* Upper piece — still in the spindle collet */}
      <g>
        {/* Collet / spindle */}
        <rect x="90" y="20" width="60" height="28" fill="currentColor" opacity="0.15" />
        <rect x="90" y="20" width="60" height="28" />
        <line x1="96" y1="48" x2="96" y2="58" />
        <line x1="108" y1="48" x2="108" y2="58" />
        <line x1="120" y1="48" x2="120" y2="58" />
        <line x1="132" y1="48" x2="132" y2="58" />
        <line x1="144" y1="48" x2="144" y2="58" />
        {/* Shank */}
        <rect x="108" y="58" width="24" height="38" fill="currentColor" opacity="0.08" />
        <rect x="108" y="58" width="24" height="38" />
        {/* Jagged snap edge on upper piece */}
        <path d="M108 96 L112 104 L118 98 L124 108 L130 100 L132 96" />
      </g>

      {/* Lower piece — broken, tumbling */}
      <g transform="translate(30 42) rotate(32 90 100)">
        {/* Jagged top edge */}
        <path d="M108 96 L112 104 L118 98 L124 108 L130 100 L132 96" />
        {/* Flutes (fluted body) */}
        <rect x="108" y="96" width="24" height="60" fill="currentColor" opacity="0.06" />
        <line x1="108" y1="96" x2="108" y2="156" />
        <line x1="132" y1="96" x2="132" y2="156" />
        {/* Flute spirals */}
        <path d="M108 104 Q120 110 132 104" />
        <path d="M108 116 Q120 122 132 116" />
        <path d="M108 128 Q120 134 132 128" />
        <path d="M108 140 Q120 146 132 140" />
        <path d="M108 152 Q120 158 132 152" />
        {/* Cutting tip */}
        <path d="M108 156 L120 168 L132 156 Z" fill="currentColor" opacity="0.2" />
        <path d="M108 156 L120 168 L132 156 Z" />
      </g>

      {/* Spark / chip lines at the snap */}
      <g opacity="0.8">
        <line x1="136" y1="92" x2="152" y2="84" />
        <line x1="140" y1="100" x2="160" y2="98" />
        <line x1="132" y1="108" x2="150" y2="118" />
        <line x1="104" y1="100" x2="86" y2="96" />
        <line x1="100" y1="108" x2="78" y2="116" />
      </g>
    </svg>
  );
}
